import { useMutation } from "urql";

import { DeleteAiPromptDocument } from "../../../../graphql/generated.ts";

export function useDeleteAIPrompt() {
  return useMutation(DeleteAiPromptDocument);
}
